// extracted by mini-css-extract-plugin
export default {"postcodeSection":"postcodeSection_postcodeSection__I1D2q","input":"postcodeSection_input__oJLs9"};